import { Car } from '@gravity-ui/icons'
import { CardTitle, Spinner } from '@heroui/react'
import { useTranslation } from 'react-i18next'

import { Card, CardContent, CardHeader } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/EmptyState'
import { useVehicleAnalyticsStore } from '@/store/vehicleAnalytics.store'

import { AdvanceByTypeChart } from './AdvanceByTypeChart'
import { CostEntriesTabs } from './CostEntriesTabs'
import { CostTimelineChart } from './CostTimelineChart'
import { DriversBreakdown } from './DriversBreakdown'
import { VehicleMetrics } from './VehicleMetrics'

export function VehicleAnalyticsDisplay() {
  const { t } = useTranslation()
  const { isLoading, filters, reports } = useVehicleAnalyticsStore()

  if (!filters.vehicleID || !filters.from || !filters.to) {
    return (
      <EmptyState
        icon={<Car className="size-8" />}
        title={t('analytics.empty_state_title')}
        description={t('vehicle_analytics.empty_state')}
      />
    )
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64 border border-dashed rounded-xl border-white/10">
        <Spinner size="lg" color={'current'} />
      </div>
    )
  }

  if (reports.length === 0) {
    return (
      <EmptyState
        icon={<Car className="size-8" />}
        title={t('analytics.no_reports')}
        description={''}
      />
    )
  }

  return (
    <div className="space-y-6">
      <VehicleMetrics />

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <Card className="flex flex-col min-h-[400px]">
          <CardHeader className="shrink-0">
            <CardTitle>{t('vehicle_analytics.cost_timeline')}</CardTitle>
          </CardHeader>
          <CardContent className="flex-1">
            <CostTimelineChart />
          </CardContent>
        </Card>

        <Card className="flex flex-col min-h-[400px]">
          <CardHeader className="shrink-0">
            <CardTitle>{t('vehicle_analytics.advance_by_type')}</CardTitle>
          </CardHeader>
          <CardContent className="flex-1">
            <AdvanceByTypeChart />
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>{t('vehicle_analytics.drivers')}</CardTitle>
        </CardHeader>
        <CardContent>
          <DriversBreakdown />
        </CardContent>
      </Card>

      <CostEntriesTabs />
    </div>
  )
}
